// extracted by mini-css-extract-plugin
export default {"app":"App_app__6Ra7L","passageCallout":"App_passageCallout__pp6EE"};